<ng-container [formGroup]="form">
  <div class="d-flex flex-column gap-2">
    @if (!isBrainstorming && !form.get('concepts').value.length) {
      <p-button
        [severity]="!subject ? 'secondary' : 'contrast'"
        (click)="onBrainstormConcepts()"
        label="Brainstorm Concepts"
        icon="pi pi-lightbulb"
        variant="outlined"
        [rounded]="true"
        size="small"
        [disabled]="!subject || isPending" />
    }
    @if (isBrainstorming) {
      <div class="d-flex justify-content-center align-items-center gap-2">
        <div class="spinner-grow text-primary" role="status">
          <span class="visually-hidden">Brainstorming concepts...</span>
        </div>
        <div>Brainstorming concepts...</div>
      </div>
    }
    @if (!isBrainstorming && form.get('concepts').value.length) {
      <div class="d-flex justify-content-between align-items-center">
        <label class="form-label" for>
          You can choose brainstormed concepts
        </label>
        <button
          type="button"
          class="btn btn-secondary btn-sm"
          (click)="regenerate()"
          [disabled]="isPending">
          Brainstorm Harder
        </button>
      </div>
      <div class="list-group" formArrayName="concepts">
        @for (item of currentConcepts; track $index) {
          <label
            class="list-group-item list-group-item-action cursor-pointer"
            [formGroupName]="item.index"
            [class.active]="item.control.get('selected').value">
            <input hidden type="checkbox" formControlName="selected" />
            {{ item.control.get('concept').value }}
          </label>
        }
      </div>
      @if (previousConcepts.length) {
        <ng-component formArrayName="concepts">
          <p-accordion value="0">
            <p-accordion-panel value="0">
              <p-accordion-header>
                Previously generated concepts:
              </p-accordion-header>
              <p-accordion-content>
                <div class="list-group p-0">
                  @for (item of previousConcepts; track $index) {
                    <label
                      class="list-group-item list-group-item-action cursor-pointer"
                      [formGroupName]="item.index"
                      [class.active]="item.control.get('selected').value">
                      <input
                        hidden
                        type="checkbox"
                        formControlName="selected" />
                      {{ item.control.get('concept').value }}
                    </label>
                  }
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </ng-component>

        <!-- <div formArrayName="concepts" ngbAccordion>
          <div ngbAccordionItem [collapsed]="true">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton>Previously generated concepts:</button>
            </h2> -->
        <!-- <div ngbAccordionCollapse>
              <div class="list-group p-0" ngbAccordionBody>
                <ng-template>
                  @for (item of previousConcepts; track $index) {
                    <label
                      class="list-group-item list-group-item-action cursor-pointer"
                      [formGroupName]="item.index"
                      [class.active]="item.control.get('selected').value">
                      <input
                        hidden
                        type="checkbox"
                        formControlName="selected" />
                      {{ item.control.get('concept').value }}
                    </label>
                  }
                </ng-template>
              </div>
            </div> -->
        <!-- </div>
        </div> -->
      }
    }
  </div>
</ng-container>
